import { defineStore, getActivePinia } from "pinia";
import useUserDataStore from "@/store/userDataStore.js";
import layoutConfig from "@/config/layoutConfig";
import globalConfig from "@/config/config.js";
import useMuseDataStore from "./museDataStore.js";
import feedListApi from "@/api/api/feedListApi.js";
import apiReferMusic from '@/api/api/apiReferMusic.js';
import message from "@/components/functionCallComponent/message.jsx";

const usePromptDataStore = defineStore({
  id: "promptDataStore",
  state: () => {
    return {
      promptData: {
        content: "",
      },
      initPresetData: true,
      promptPresetData: {},
      promptPresetDataShow: {},
      renderKeysSorts: [
        "genres",
        "moods",
        "vocals",
        "instrumentals",
        "rhythms",
      ],
      renderPresetData: [],
      renderPresetDataHasAddData: [],
      typeTagDataMap: null,
    };
  },
  actions: {
    initPromptData(data) {
      this.updatePromptData(data?.prompt ?? null);
    },
    setCurPromptData(data) {
      this.updatePromptData(data);
    },
    setPromptDataContent(str) {
      if (this.promptData) {
        this.promptData.content = str;
      } else {
        this.promptData = {
          content: str,
        };
      }
      this.updatePromptData(this.promptData);
    },
    setPromptData(data) {
      this.updatePromptData(data);

    },
    updatePromptData(data) {
      this.promptData = data;
      useMuseDataStore().setPromptData(data);
    },
    getPromptData() {
      return this.promptData;
    },
    deletePromptDataByAudit() {
      this.promptData = {
        content: "",
      };
    },
    getAllPromptPresetDatas(data) {
      return new Promise((resolve, reject) => {
        feedListApi
          .getPromptPresetData({
            ...data,
          })
          .then((res) => {
            if (res.code === 200) {
              this.initState = "presetData";
              this.setPromptPresetData(res.data);
              resolve();
            } else {
              reject("get prompt presetData error");
            }
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    changebatchPromptPresetData(data) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      return new Promise((resolve, reject) => {
        feedListApi
          .changebatchPromptPresetData({
            shown: this.promptPresetDataShow,
            remain: this.promptPresetData,
            ...data,
          })
          .then((res) => {
            let curShown = Object.values(
              this.promptPresetDataShow ?? {}
            ).reduce((res, cur) => {
              if (cur) {
                res = res.concat(cur);
              }
              return res;
            }, []);
            if (res.code == 200) {
              if (
                (!Object.values(res.data?.shown ?? {}).some((i) => i?.length) &&
                  !Object.values(res.data?.remain ?? {}).some(
                    (i) => i?.length
                  )) ||
                curShown.sort().join(",") ===
                Object.values(res.data?.shown ?? {})
                  .reduce((res, cur) => {
                    if (cur) {
                      res = res.concat(cur);
                    }
                    return res;
                  }, [])
                  .concat(
                    Object.values(res.data?.remain ?? {}).reduce(
                      (res, cur) => {
                        if (cur) {
                          res = res.concat(cur);
                        }
                        return res;
                      },
                      []
                    )
                  )
                  .sort()
                  .join(",")

                //     ||
                // (Object.values(res.data?.shown ?? {})
                //   .reduce((res, cur) => {
                //     if (cur) {
                //       res = res.concat(cur);
                //     }
                //     return res;
                //   }, [])
                //   .sort()
                //   .join(",") === curShown.sort().join &&
                //   Object.values(res.data?.remain ?? {})
                //     .reduce((res, cur) => {
                //       if (cur) {
                //         res = res.concat(cur);
                //       }
                //       return res;
                //     }, [])
                //     .sort()
                //     .join(",") ==
                //     Object.values(this.promptPresetData ?? {})
                //       .reduce((res, cur) => {
                //         if (cur) {
                //           res = res.concat(cur);
                //         }
                //         return res;
                //       }, [])
                //       .sort())
              ) {
                message.info({
                  content: $$t("create.no_more_prompt_tags"),
                  position: "top",
                });
              } else {
                this.setPromptPresetData(res.data);
              }

              resolve();
            } else {
              if (res.code === 9008) {
                // message.info({
                //   content: $$t("create.tooFrequently"),
                //   position: "top",
                // })
                reject("get batch prompt too frequently");
              } else {
                message.error({
                  position: "top",
                  content: $$t("create.get_prompt_tags_failed"),
                })
                reject("get batch prompt presetData error");
              }

            }
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    getRemainRecommendPromptPresetData(data) {
      let res = {};
      this.renderKeysSorts.forEach((key) => {
        res[key] = (data.shown?.[key] ?? []).concat(data.remain?.[key] ?? []);
      });
      return res;
    },
    deleteRecommendPromptPresetData() {
      let dataTime = new Date().getTime();
      this.changeRecommendPromptPresetDataTime = dataTime;
      this.setPromptPresetData(
        {
          shown: {},
          remain: {},
        },
        true
      )
    },
    changeRecommendPromptPresetData(data) {
      const pinia = getActivePinia()
      const { $$t } = pinia?.$i18n ?? {}
      let dataTime = new Date().getTime();
      this.changeRecommendPromptPresetDataTime = dataTime;
      return new Promise((resolve, reject) => {
        feedListApi
          .changeRecommendPromptPresetData({
            tags:
              this.initState == "recommendData"
                ? this.promptPresetDataShow?.genres ?? []
                : [],
            ...data,
          })
          .then((res) => {
            if (this.changeRecommendPromptPresetDataTime != dataTime) {
              reject("abandon request");
              return;
            }
            let curShown = Object.values(
              this.promptPresetDataShow ?? {}
            ).reduce((res, cur) => {
              if (cur) {
                res = res.concat(cur);
              }
              return res;
            }, []);
            if (res.code === 200) {
              if (!res.data?.tags?.length) {
                this.initState = "recommendData";
                this.setPromptPresetData(
                  {
                    shown: res.data?.shown ?? {},
                    remain: res.data?.remain ?? {},
                  },
                  true
                );
              } else {
                this.initState = "recommendData";
                if (
                  curShown.sort().join(",") === res.data?.tags?.sort().join(",")
                ) {
                  // message.info({
                  //   content: $$t("create.no_more_prompt_tags"),
                  //   position: "top",
                  // });
                }
                this.setPromptPresetData(
                  {
                    shown: {
                      genres: res.data?.tags ?? [],
                    },
                    remain: this.getRemainRecommendPromptPresetData(res.data),
                  },
                  true
                );
              }

              resolve();
            } else {
              if (res.code === 9008) {
                // message.info({
                //   content: $$t("common.tooFrequently"),
                //   position: "top",
                // })
                reject("get batch prompt too frequently");
              } else {
                message.error({
                  position: "top",
                  content: $$t("create.get_prompt_tags_failed"),
                })
                reject("get batch prompt presetData error");
              }
            }
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    setPromptPresetData(data, autocomplete = false) {
      this.promptPresetDataShow = data?.shown ?? {};
      this.promptPresetData = data?.remain ?? {};
      this.renderPresetDataHasAddData = [];
      // 曲风→情绪→人声→乐器→节奏
      this.renderPresetData = this.renderKeysSorts
        .reduce((res, cur) => {
          if (this.promptPresetDataShow[cur]) {
            res = res.concat(
              this.promptPresetDataShow[cur].map((item) => {
                return {
                  content: item,
                  type: cur,
                  show: true,
                };
              })
            );
            return res;
          }
          return res;
        }, [])
        .concat(
          this.renderKeysSorts.reduce((res, cur) => {
            if (this.promptPresetData[cur]) {
              res = res.concat(
                this.promptPresetData[cur].map((item) => {
                  return {
                    content: item,
                    type: cur,
                    show: false,
                  };
                })
              );
              return res;
            }
            return res;
          }, [])
        );
      if (autocomplete) {
        let length = Object.values(this.promptPresetDataShow).reduce(
          (res, cur) => {
            return res + cur.length;
          },
          0
        );
        if (length < 10) {
          for (let i = 0; i < 10 - length; i++) {
            this.renderKeysSorts.some((key) => {
              if (this.promptPresetData[key]?.length) {
                this.promptPresetDataShow[key]?.push(
                  this.promptPresetData[key]?.shift()
                );
                return true;
              }
            });
          }
        }
      }
    },
    initLibraryData() {
      this.typeTagDataMap = null;
    },
    initPromptTypeTags() {
      return new Promise((resolve, reject) => {
        if (this.typeTagDataMap) {
          resolve(this.typeTagDataMap)
        } else {
          apiReferMusic.getPromptTypeTags().then((res) => {
            if (res?.code === 200) {
              this.typeTagDataMap = {
                genres: res?.data?.genres ?? [],
                moods: res?.data?.moods ?? [],
                vocals: res?.data?.vocals ?? [],
              }
              resolve(this.typeTagDataMap)
            } else {
              reject(res)
            }
          }).catch((err) => {
            reject(err)
          })
        }
      })
    }
  },

});

export default usePromptDataStore;
